"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Infodialog zur Ausgabe der Detailinformationen.
 *
 * @class
 * @memberof gc.gis.module.GCFeatureInfo
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.module.GCFeatureInfo.InfoDialog = function()
{
    gc.gis.widget.GCWidget.call(this, {
        className: 'gc-featureinfo-dialog-content'
    });

    var self = this;

    /**
     * @type {gc.gis.widget.GCPopup}
     * @private
     */
    this._popup = new gc.gis.widget.GCPopup({
        title: 'Objekt-Informationen',
        content: this.getElement(),
        className: 'gc-featureinfo-dialog',
        close: function(target, evt) {
            self._onClose();
        }
    });

    /**
     * Liste der Content-Elemente, die dem Dialog hinzugefügt wurden.
     *
     * @type {jQuery[]}
     * @private
     */
    this._content_elements = [];
};
gc.gis.module.GCFeatureInfo.InfoDialog.prototype = Object.create(gc.gis.widget.GCWidget.prototype);

/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfo.InfoDialog.prototype._render = function()
{
    this.element = jQuery('<div>', {
        class: this.className
    });
    this.div_load = jQuery('<div>', {
        class: 'loading-indicator',
        html: '<span class="loading-indicator-label"><em>Lade Objektinformationen ... </em></span>'
    });
    this.div_load.hide();

    this.element.append(this.div_load);
    return this.element;
};

/**
 * Setzt den Inhalt des Dialogs.
 *
 * @param {jQuery} contentElement
 * @return {jQuery} das gesetzte Element
 * @public
 */
gc.gis.module.GCFeatureInfo.InfoDialog.prototype.setContentElement = function(contentElement)
{
    this.clear();
    return this.addContent(contentElement, gc.gis.module.GCFeatureInfoDetailResultTypes.INLINE_HTML);
};

/**
 * Fügt ein Inhaltselement dem Dialog hinzu.
 *
 * @param {string|jQuery} content
 * @param {gc.gis.module.GCFeatureInfoDetailResultTypes} contentType Conten-Type des FeatureInfo-Inhalts
 * @return {jQuery} das hinzugefügte Element
 * @public
 */
gc.gis.module.GCFeatureInfo.InfoDialog.prototype.addContent = function(content, contentType)
{
    const inIframe = contentType === gc.gis.module.GCFeatureInfoDetailResultTypes.HTML
        ||contentType === gc.gis.module.GCFeatureInfoDetailResultTypes.HTML_THIRD_PARTY;
    const sandboxIframe = contentType === gc.gis.module.GCFeatureInfoDetailResultTypes.HTML_THIRD_PARTY;

    let element;
    if (content instanceof jQuery)
    {
        element = content;
    }
    else if (inIframe)
    {

        if (sandboxIframe)
        {
            element = jQuery('<iframe style="width: 100%; height: 500px;" src="' + content + '" sandbox>');
        }
        else
        {
            element = jQuery('<iframe style="width: 100%; height: 500px;">');
            element.on('load', function (evt) {
                // content nur beim ersten Laden des iFrames setzen, dann nicht mehr (z.B. wenn Link innerhalb des iFrame geklickt wird)
                const childs = jQuery(this).contents().find('body').children();
                if (0 === childs.length)
                {
                    this.contentDocument.open();
                    this.contentDocument.write(content);
                    this.contentDocument.close();
                }
            });
        }
    }
    else
    {
        element = jQuery('<div>', {
            'html': content
        });
    }

    this._content_elements.push(element);
    this.getElement().append(element);

    return element;
};

/**
 * Setzt den Inhalt des Dialogs zurück.
 *
 * @public
 */
gc.gis.module.GCFeatureInfo.InfoDialog.prototype.clear = function()
{
    while (this._content_elements.length > 0) {
        this._content_elements.pop().remove();
    }
};

/**
 * Zeigt eine Ladeanimation mit angegebenem Text im Dialog an.
 *
 * @param {boolean} visible
 * @public
 */
gc.gis.module.GCFeatureInfo.InfoDialog.prototype.setAnimationVisibility = function(visible)
{
    if (visible) {
        this.div_load.show();
    }
    else {
        this.div_load.hide();
    }
};

/**
 * Zeigt den Dialog an.
 *
 * @method
 * @public
 */
gc.gis.module.GCFeatureInfo.InfoDialog.prototype.show = function()
{
    this._popup.show();
};

/**
 * Schließt den Dialog an.
 *
 * @method
 * @public
 */
gc.gis.module.GCFeatureInfo.InfoDialog.prototype.close = function()
{
    this._onClose();
};

/**
 * Führt die Bearbeitung zum Schließen des Dialog aus.
 *
 * @method
 * @protected
 */
gc.gis.module.GCFeatureInfo.InfoDialog.prototype._onClose = function()
{
    this._popup.close();
    this._fireEvent(gc.gis.module.GCFeatureInfoEvent.INFO_DIALOG_CLOSED, {});
};
